export const laoTableConstants= {
    LAO_TABLE_LOADING: 'LAO_TABLE_LOADING',
    LAO_TABLE_SUCCESS: 'LAO_TABLE_SUCCESS',
    LAO_TABLE_FAILED: 'LAO_TABLE_FAILED',
  }